import React from "react";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { truncateText } from "../../../../utils";

const BoardCheckbox = ({ board, checked, onSelect, isEpic, ...props }) => {
  return (
    <CustomMenuItem
      key={`board-list-my-task-${board?.board_id}`}
      className="custom-border"
      onClick={(event) => {
        // Removed onSelect call from here to prevent double calls
        onSelect(event, isEpic ? board?.epic_id : board?.board_id);
      }}
      {...props}>
      <label className="custom-checkbox">
        <input
          type="checkbox"
          id={`board-list-my-task-checkbox-${board?.board_id}`}
          checked={checked}
          onClick={(event) => {
            event.stopPropagation();
          }}
          onChange={(event) => {
            "";
          }}
        />
        <span className="checkmark"></span>
        <p className="board-name-filter">
          {truncateText(isEpic ? board?.epic_name : board?.board_name, 26)}
        </p>
      </label>
    </CustomMenuItem>
  );
};

export default BoardCheckbox;
